import _axios from '@/utils/request'

// 全部的banner列表
export function postBannerList (params) {
    return _axios('post', '/ms-shulan-hospital/v1/patient-banner/list', params)
}
// 删除banner
export function deleteBanner (bannerId) {
    return _axios('delete', `/ms-shulan-hospital/v1/patient-banner/${bannerId}`)
}

// 下线banner
export function postDismountedBanner (bannerId) {
    return _axios('post', `/ms-shulan-hospital/v1/patient-banner/dismountedBanner/${bannerId}`)
}

// 上线banner
export function postShelfBanner (bannerId) {
    return _axios('post', `/ms-shulan-hospital/v1/patient-banner/shelfBanner/${bannerId}`)
}

// 添加banner
export function postAddBanner (params) {
    return _axios('post', '/ms-shulan-hospital/v1/patient-banner/add', params)
}

// 更新banner
export function putBanner (params) {
    return _axios('post', '/ms-shulan-hospital/v1/patient-banner/update', params)
}

// 获取banner
export function getBanner (bannerId) {
    return _axios('get', `/ms-shulan-hospital/v1/patient-banner/${bannerId}`)
}

// 上移banner
export function getBannerMoveUp (bannerId) {
    return _axios('get', `/ms-shulan-hospital/v1/patient-banner/moveUp/${bannerId}`)
}

// 下移banner
export function getBannerMoveDown (bannerId) {
    return _axios('get', `/ms-shulan-hospital/v1/patient-banner/moveDown/${bannerId}`)
}
